export default __webpack_public_path__ + "static/media/12.cd5be31a.png";